export default __webpack_public_path__ + "static/media/0x9c1c23e60b72bc88a043bf64afdb16a02540ae8f.0bf21145.webp";